import React from 'react'
import { FormattedMessage } from 'react-intl'

import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { TaskModal } from './TaskModal'

export type EditTaskModalProps = {
  visible: boolean
  initialDescription: string
  onConfirm: (description: string) => Promise<void>
  onMarkDone: () => Promise<void>
  onClose: () => void
}

export const EditTaskModal: React.FC<EditTaskModalProps> = ({
  visible,
  initialDescription,
  onConfirm,
  onMarkDone,
  onClose,
}) => (
  <TaskModal
    visible={visible}
    onClose={onClose}
    title={<FormattedMessage defaultMessage='Edit task' description='Edit task modal title' />}
    initialDescription={initialDescription}
    primaryButtonText={<FormattedMessage defaultMessage='Confirm' description='Edit task modal primary button' />}
    onPrimaryPress={onConfirm}
    secondaryButton={{
      text: <FormattedMessage defaultMessage='Mark as done' description='Edit task modal mark-as-done button' />,
      onPress: onMarkDone,
    }}
    testID={tID('EditTaskModal')}
  />
)
